import {Request} from '@simpli/serialized-request'

type DateValue = Date | string | number | null

export class OrbitReportPeriod {
  startsAt: DateValue = null
  endsAt: DateValue = null
  totalEvents: number = 0
  uniqueTransactions: number = 0
  uniqueAddresses: number = 0
  newAddresses: number = 0
  activeProjects: number = 0
  activeRounds: number = 0
  approvedRewards: number = 0
  claimedRewards: number = 0
  rewardedAddresses: number = 0
  claimedGas: number = 0
}

export class OrbitReportEventCount {
  idContract: number | null = null
  projectTitle: string | null = null
  contractHash: string | null = null
  networkIdentifier: string | null = null
  eventname: string | null = null
  currentMonthCount: number = 0
  previousMonthCount: number = 0
  currentMonthAddresses: number = 0
  previousMonthAddresses: number = 0
}

export class OrbitReportDailyCount {
  day: string | null = null
  events: number = 0
  addresses: number = 0
}

export class OrbitReportRound {
  round: number | null = null
  networkIdentifier: string | null = null
  startsAt: DateValue = null
  endsAt: DateValue = null
  isRunning: boolean = false
  projectCount: number = 0
  totalEvents: number = 0
  participants: number = 0
  claimedRewards: number = 0
}

export class OrbitReportTransaction {
  transactionHash: string | null = null
  transactionDate: DateValue = null
  projectTitle: string | null = null
  contractHash: string | null = null
  networkIdentifier: string | null = null
  eventname: string | null = null
  address: string | null = null
}

export class OrbitReport {
  networkIdentifier: string | null = null
  generatedAt: DateValue = null
  currentMonth = new OrbitReportPeriod()
  previousMonth = new OrbitReportPeriod()
  events: OrbitReportEventCount[] = []
  dailyActivity: OrbitReportDailyCount[] = []
  rounds: OrbitReportRound[] = []
  transactions: OrbitReportTransaction[] = []

  static async getMonthlyReport(
    networkIdentifier: string | null
  ): Promise<OrbitReport> {
    const raw = await Request.get(`/client/orbit-report/monthly`, {
      params: {networkIdentifier},
    })
      .name('getOrbitMonthlyReport')
      .asAny()
      .getData()

    return Object.assign(new OrbitReport(), raw)
  }
}
